
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"39","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.06 16.24A4.066 4.066 0 000 20.3V33.29a4.066 4.066 0 004.06 4.06h4.872a4.03 4.03 0 002.436-.822V16.24H4.06z","fill":"#0083FF"}}),_c('path',{attrs:{"d":"M38.975 22.33c0-.977-.387-1.886-1.058-2.557a4.032 4.032 0 001.04-3.1c-.19-2.064-2.05-3.681-4.235-3.681H24.69c.497-1.51 1.293-4.275 1.293-6.496C25.983 2.973 22.99 0 21.111 0c-1.687 0-2.892.95-2.944.989a.816.816 0 00-.304.635V7.13l-4.676 10.131-.195.1v17.405c1.321.624 2.994.96 4.06.96h14.906c1.768 0 3.316-1.192 3.68-2.837a3.654 3.654 0 00-.294-2.44 3.638 3.638 0 001.625-4.873 3.635 3.635 0 002.006-3.248z","fill":"#0183FE"}})])
          )
        }
      }
    